import { reactQueryClient } from '@app/reactQueryClient';

import { useAuthTokens } from '../auth/useAuthTokens';

import { callGetAccounts } from './request';

export const CURRENT_USER_ACCOUNTS = 'current-user-accounts';

export async function initializeWallets() {
    const isAuthenticated = useAuthTokens.getState().isAuthenticated;
    const currentUserId = useAuthTokens.getState().currentUserId;

    if (!isAuthenticated || !currentUserId) return;
    try {
        await reactQueryClient.prefetchInfiniteQuery({
            queryKey: [CURRENT_USER_ACCOUNTS],
            queryFn: ({ signal }) =>
                callGetAccounts({
                    variables: {
                        userFilter: currentUserId,
                        withCollectibles: false,
                        cursorInput: {
                            limit: 100,
                            cursor: null,
                        },
                    },
                    settings: { signal },
                }),
            initialPageParam: '',
            staleTime: Infinity,
            retry: false,
        });
    } catch (e) {
        // TODO: This is currently outputting a huge error on console
        // related to GraphQL: https://nomatter.tari.com/tari/pl/9osu64n8hjbt7cpdx3eiwsg9ow
        // const message = getErrorMessage(e);
        // addNewToast({ message, minimal: true });
    }
}
